import { render, staticRenderFns } from "./AlertTable.vue?vue&type=template&id=8db9f504&scoped=true&"
import script from "./AlertTable.vue?vue&type=script&lang=js&"
export * from "./AlertTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertTable.vue?vue&type=style&index=0&id=8db9f504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db9f504",
  null
  
)

export default component.exports